import { render, staticRenderFns } from "./DisClaimerModal.vue?vue&type=template&id=ed46e4ee&"
import script from "./DisClaimerModal.vue?vue&type=script&lang=js&"
export * from "./DisClaimerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports